import React from "react";
import {createMuiTheme, ThemeProvider} from "@material-ui/core";

const theme = createMuiTheme({
    overrides:{
        MuiAppBar: {
            root: {
                backgroundColor: '#fff !important'
            }
        }
    }
})

export default class AllWhite extends React.Component{
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        document.body.style.backgroundColor = '#fff'
    }

    componentWillUnmount() {
        document.body.style.backgroundColor = null
    }

    render(){
        return (
            <ThemeProvider theme={theme}>
                {this.props.children}
            </ThemeProvider>
        )
    }
}